import { useState } from 'react';

export const usePagination = () => {
  const [page, setPage] = useState<number>(1);
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return {
    page,
    handleChange,
  };
};
